import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Button, Grid, makeStyles } from "@material-ui/core";
import CircularProgresss from "views/components/CircularProgress/CircularProgress";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { useSelector } from "react-redux";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
// import Button from "../../components/CustomButtons/Button"
import CustomTextField from "components/UpdateUi/CustomeTextField";
import CustomDateField from "components/UpdateUi/CustomDateField";
import CustomSelect from "components/UpdateUi/CustomeSelect";
import { parseDate } from "utils/Utils";
import brandTheme from "brandTheme/Theme";
import Camera from "react-html5-camera-photo";
import "react-html5-camera-photo/build/css/index.css";
import FileUpload from "views/components/FileUpload/FileUpload";
import ToastModal from "views/components/ToastModal";

const useStyles = makeStyles((theme) => ({
  container: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    width: "92%",
    margin: "0 auto",
    minHeight: "85vh",
    overflow: "hidden",
  },
  content: {
    flexGrow: 1,
    overflowY: "auto",
    paddingBottom: theme.spacing(2),
  },
  footer: {
    textAlign: "end",
    padding: theme.spacing(2),
    background: "#fff",
    position: "sticky",
    bottom: 0,
  },
  inputFieldContainer: {
    margin: "0 auto",
    maxWidth: "1100px",
  },
  fieldContaienr: {
    margin: "2% 2% 0px 15%",
    maxWidth: "31.3%",
    "@media (max-width: 768px)": {
      maxWidth: "46%",
      margin: "5% 2% 0px 2%",
    },
    "@media (max-width: 600px)": {
      maxWidth: "100%",
    },
    "@media (max-width: 450px)": {
      margin: "10% 2% 0px 2%",
    },
  },
  nextButton1: {
    boxShadow: "inherit",
    color: brandTheme.white,
    margin: "10px 10px 10px 0 ",
    padding: "0px 40px",
    height: "40px",
    width: "100px",
    textTransform: "capitalize",
    background: "linear-gradient(135deg, #15254F 0%, #1CB167 50%, #28D17F 100%)",
    "&:hover": {
      background: "linear-gradient(135deg, #15254F 0%, #1CB167 50%, #28D17F 100%)",
      boxShadow: "inherit",
    },
    "&:focus": {
      background: "linear-gradient(135deg, #15254F 0%, #1CB167 50%, #28D17F 100%)",
      boxShadow: "inherit",
    },
  },
  imageContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "20px",
    marginRight: "160px",
  },
}));

const PanDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const classes = useStyles();

  const [panImage, setPanImage] = useState("");
  const [panImageUrl, setPanImageUrl] = useState("");
  const [callInProgress, setCallInProgress] = useState(false);

  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");

  const { authToken } = useSelector((state) => state.login.authData);

  const { leadId } = useSelector(
    (state) => state.login.userCurrentLead
  );

  const { mobileNumber } = useSelector(
    (state) => state.login.userData
  );

  const [panData, setPanData] = useState({});
  const [panDataPresent, setPanDataPresent] =
    useState(false);

  const [disaledFields, setDisabledFields] =
    useState(false);

  const [showCamera, setShowCamera] =
    useState(false);

  console.log(leadId, "fsskjkjbfkjsdbv");

  const toastUpdate = (
    type,
    message,
    showToast
  ) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };

  useEffect(() => {
    getPanData();
    getUserDocumentDetails();
  }, []);

  const getUserDocumentDetails = async (
    type
  ) => {
    setCallInProgress(true);

    const result = await apiHandler({
      url:
        endpoint.GET_LEAD_ALL_DOCUMENTS_API +
        leadId +
        "/documents",
      method: "GET",
      authToken: authToken,
    });

    setCallInProgress(false);

    console.log(result?.data, "API DATA");

    if (result?.data?.pancardLink) {
      setPanImage(result?.data?.pancardLink);

      if (type) {
        setPanDataPresent(false);
      } else {
        setPanDataPresent(true);
      }
    }
  };

  const getPanData = async () => {
    const res = await apiHandler({
      url:
        endpoint.GET_USER_PAN_DETAILS_API +
        mobileNumber,
      authToken: authToken,
    });

    if (res?.data?.dob) {
      setPanData(res?.data);
    }
  };

  const onClickCamera = () => {
    setShowCamera(!showCamera);
  };

  const handleCameraError = (error) => {
    console.log("handleCameraError", error);
  };

  const handleCameraStart = (stream) => {
    console.log("handleCameraStart");
  };

  const handleCameraStop = () => {
    console.log("handleCameraStop");
  };

  const handleTakePhoto = async (
    dataUri,
    type
  ) => {
    console.log(dataUri, "dataUri1111");

    // hide camera after capture
    setShowCamera(false);

    const blob = await fetch(dataUri).then((res) =>
      res.blob()
    );

    uploadPanData(blob, type);
  };

  const uploadPanData = async (
    blob,
    fileName
  ) => {
    setCallInProgress(true);

    const formData = new FormData();

    formData.append("file", blob, fileName);

    formData.append(
      "leadApplicationId",
      leadId
    );

    formData.append(
      "panNumber",
      panData?.panNumber
    );

    const res = await apiHandler({
      url: endpoint.USER_UPLOAD_PAN_CARD_API,
      method: "POST",
      authToken: authToken,
      data: formData,
    });

    setCallInProgress(false);

    if (res?.data?.error_code) {
      toastUpdate(
        "Error",
        res.data.user_description,
        true
      );
    } else {
      toastUpdate(
        "Success",
        "Image Uploaded Successfully",
        true
      );

      getUserDocumentDetails("firstTime");
    }
  };

  console.log(panImage, "panImage");

  const handleNext = async () => {
    setShowCamera(false);

    navigate("/journey/SelfiePhoto");
  };

  return (
    <Grid container className={classes.container}>
      <Grid item xs={12}>
        <SubHeader
          label="Pan Card Details"
          button1={"Next"}
          button1click={handleNext}
          disabled1={!panImage}
        />
      </Grid>

      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        className={classes.inputContainer}
      >
        <Grid
          container
          className={classes.inputFieldContainer}
        >
          {!panDataPresent && (
            <>
              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                className={classes.fieldContaienr}
              >
                <Button
                  size="small"
                  onClick={() => onClickCamera()}
                  className={classes.nextButton1}
                  aria-label="upload report"
                >
                  {showCamera
                    ? "Close"
                    : "Camera"}
                </Button>
              </Grid>

              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                className={classes.fieldContaienr}
              >
                {!showCamera && <FileUpload
                  addButtonProps={{
                    color: brandTheme.buttonColor,
                    round: false,
                  }}
                  supportedMimeType={[
                    "image/jpeg",
                    "image/jpg",
                    "image/bmp",
                    "image/png",
                    "image/tiff",
                  ]}
                  sendFile={(file) => {
                    // hide camera when upload clicked
                    setShowCamera(false);

                    uploadPanData(
                      file,
                      "panCardImage"
                    );
                  }}
                />}
              </Grid>
            </>
          )}
        </Grid>

        <Grid container>
          {showCamera && (
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
            >
              <Camera
                style={{
                  width: "40vh",
                  height: "40vh",
                }}
                onTakePhoto={(dataUri) => {
                  handleTakePhoto(
                    dataUri,
                    "panCardImage"
                  );
                }}
                onCameraError={(error) => {
                  handleCameraError(error);
                }}
                isMaxResolution={true}
                isFullscreen={false}
                sizeFactor={2}
                onCameraStart={(stream) => {
                  handleCameraStart(stream);
                }}
                onCameraStop={() => {
                  handleCameraStop();
                }}
              />
            </Grid>
          )}

          {panImage !== "" && (
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              className={
                classes.imageContainer
              }
            >
              <img
                src={panImage}
                width="500"
                height="300"
                alt="panImage"
              />
            </Grid>
          )}
        </Grid>
      </Grid>

      {callInProgress && (
        <CircularProgresss
          callInProgress={callInProgress}
        />
      )}

      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={
            toastMessageType
          }
          toastUpdate={toastUpdate}
        />
      )}
    </Grid>
  );
};

export default PanDetails;